import { Router } from "express";

import { alertController } from "../controllers/alert-controller";
import { authenticate, createRateLimit } from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";

const router = Router();

// Environment-aware rate limiting
const generalRateLimit = createRateLimit.general();

/**
 * Student Alert Routes
 */

/**
 * @route   POST /api/v1/student/alerts
 * @desc    Create an escort or emergency alert
 * @access  Private (Student)
 */
router.post(
  "/student/alerts",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => alertController.createAlert(req, res),
);

/**
 * @route   GET /api/v1/student/alerts
 * @desc    Get all alerts for authenticated student
 * @access  Private (Student)
 */
router.get(
  "/student/alerts",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => alertController.getStudentAlerts(req, res),
);

/**
 * @route   PUT /api/v1/student/alerts/:id/cancel
 * @desc    Cancel an alert
 * @access  Private (Student)
 */
router.put(
  "/student/alerts/:id/cancel",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => alertController.cancelAlert(req, res),
);

router.put(
  "/student/alerts/:id/location",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => alertController.updateAlertLocation(req, res),
);

/**
 * Teacher Alert Routes
 */

/**
 * @route   POST /api/v1/teacher/alerts
 * @desc    Create an escort or emergency alert (Teacher)
 * @access  Private (Teacher)
 */
router.post(
  "/teacher/alerts",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => alertController.createTeacherAlert(req, res),
);

/**
 * @route   GET /api/v1/teacher/alerts
 * @desc    Get all alerts for authenticated teacher
 * @access  Private (Teacher)
 */
router.get(
  "/teacher/alerts",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => alertController.getTeacherAlerts(req, res),
);

router.get(
  "/teacher/alerts/:id",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => alertController.getTeacherAlertById(req, res),
);

router.put(
  "/teacher/alerts/:id/acknowledge",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => alertController.acknowledgeTeacherAlert(req, res),
);

router.put(
  "/teacher/alerts/:id/resolve",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => alertController.resolveTeacherAlert(req, res),
);

/**
 * @route   PUT /api/v1/teacher/alerts/:id/cancel
 * @desc    Cancel an alert (Teacher)
 * @access  Private (Teacher)
 */
router.put(
  "/teacher/alerts/:id/cancel",
  authenticate,
  requireRole(["teacher"]),
  generalRateLimit,
  (req, res) => alertController.cancelTeacherAlert(req, res),
);

/**
 * School Alert Routes
 */

/**
 * @route   POST /api/v1/school/alerts
 * @desc    Create an escort or emergency alert (School Admin)
 * @access  Private (School Admin)
 */
router.post(
  "/school/alerts",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => alertController.createSchoolAlert(req, res),
);

/**
 * @route   GET /api/v1/school/alerts
 * @desc    Get all alerts for school panel
 * @access  Private (School Admin)
 */
router.get(
  "/school/alerts",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => alertController.getSchoolAlerts(req, res),
);

/**
 * @route   PUT /api/v1/school/alerts/:id/acknowledge
 * @desc    Acknowledge an alert
 * @access  Private (School Admin)
 */
router.put(
  "/school/alerts/:id/acknowledge",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => alertController.acknowledgeAlert(req, res),
);

/**
 * @route   PUT /api/v1/school/alerts/:id/assign
 * @desc    Assign an alert
 * @access  Private (School Admin)
 */
router.put(
  "/school/alerts/:id/assign",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => alertController.assignAlert(req, res),
);

/**
 * @route   PUT /api/v1/school/alerts/:id/resolve
 * @desc    Resolve an alert
 * @access  Private (School Admin)
 */
router.put(
  "/school/alerts/:id/resolve",
  authenticate,
  requireRole(["school"]),
  generalRateLimit,
  (req, res) => alertController.resolveAlert(req, res),
);

/**
 * Admin Alert Routes
 */

/**
 * @route   POST /api/v1/admin/alerts
 * @desc    Create an escort or emergency alert (Admin)
 * @access  Private (Admin)
 */
router.post(
  "/admin/alerts",
  authenticate,
  requireRole(["admin"]),
  generalRateLimit,
  (req, res) => alertController.createAdminAlert(req, res),
);

export default router;
